import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class EnumModel extends BaseModel {
  @attr("json") key; // Handled as JSON to avoid transformation
  @attr("string") name;
  @attr("string") value;
  @attr("string") label;
  @attr("string") description;
  @attr("string") reason;
  @attr("number") order;
}
